import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { useSetDataByView } from "../../hooks/useSetDataByView/useSetDataByView.ts";
import { useShowToast } from "../../contexts/ToastContext.tsx";
import { ProductEntry } from "../../types/shared.ts";

export default function DeleteProduct({ rowData }: { rowData: ProductEntry }) {
  const { deleteData } = useSetDataByView();
  const showToast = useShowToast();

  const confirmRemove = () => {
    confirmDialog({
      message: `Czy na pewno chcesz usunąć "${rowData.name}"?`,
      header: "Potwierdź usunięcie",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Usuwać",
      rejectLabel: "Anulować",
      accept: () => {
        void (async () => {
          try {
            await deleteData(rowData.id);
            showToast({
              severity: "success",
              summary: "Towar usunięte",
              detail: `${rowData.name} został usunięty`,
            });
          } catch (_error) {
            showToast({
              severity: "error",
              summary: "Błąd",
              detail: "Nie udało się usunąć",
            });
          }
        })();
      },
      acceptClassName: "p-button-danger",
      className: "custom-confirm-dialog",
    });
  };

  return (
    <Button
      size="small"
      icon="pi pi-trash"
      text
      severity="danger"
      onClick={(e) => {
        e.stopPropagation();
        confirmRemove();
      }}
    />
  );
}
